<!-- ::::::::::: NAVBAR :::::::::::::::-->
<!-- <div class="fixed-top">
    <div class="container">
        <nav class="navbar navbar-expand-lg navbar-light">
            <div class="container-fluid p-0">
                <a class="navbar-brand" href="index.html"><img src="assets/logo.jpg" alt="Landing Page" width="70"></a>
                <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
                </button>
                <div class="collapse navbar-collapse" id="navbarNav">
                    <ul class="navbar-nav me-auto mx-auto list-group list-group-flush">
                        <li class="nav-item list-group-item list-menu-item">
                            <a class="nav-link active" aria-current="page" [routerLink]="['/home']">{{'Home' | translate}}</a>
                        </li>
                        <li class="nav-item list-group-item list-menu-item">
                            <a class="nav-link" [routerLink]="['/projects']">{{'Projects' | translate}}</a>
                        </li>
                        <li class="nav-item list-group-item list-menu-item">
                            <a class="nav-link" [routerLink]="['/service']">{{'Services' | translate}}</a>
                        </li>
                        <li class="nav-item list-group-item list-menu-item">
                            <a class="nav-link" [routerLink]="['/about-us']">{{'About Us' | translate}}</a>
                        </li>
                        <li class="nav-item list-group-item list-menu-item">
                            <a class="nav-link"[routerLink]="['/facilities']">{{'Facilities' | translate}}</a>
                        </li>
                        <li class="nav-item list-group-item list-menu-item">
                            <a class="nav-link" [routerLink]="['/contact-us']">{{'Contact' | translate}}</a>
                        </li>
                        <li class="nav-item nav-dropdown list-group-item list-menu-item">
                            <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">{{'Language' | translate}}</a>
                            <div class="dropdown-menu" aria-labelledby="navbarDropdown">
                                <a class="dropdown-item" (click)="switchLang('en')">{{'English' | translate}}</a>
                                <a class="dropdown-item" (click)="switchLang('cn')">{{'Chinese' | translate}}</a>
                            </div>
                        </li>
                    </ul>
                    <span class="navbar-text d-none d-lg-inline">
                        <a  class="text-decoration-none"><i class="fas fa-phone" style="font-size: 12px;"></i>  +603 92016799</a>
                    </span>
                </div>
            </div>
        </nav>
    </div>
</div> -->
<!-- ::::::::::: /END NAVBAR ::::::::::-->


<div class="fixed-top">
    <div class="container">
        <nav class="navbar navbar-expand-lg navbar-light">
            <div class="container-fluid p-0" data-aos="fade" data-aos-duration="800" data-aos-easing="ease-in-out">
                <a class="navbar-brand" [routerLink]="['/home']"><img src="assets/logo.jpg" alt="Landing Page" width="100"></a>
                <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
                </button>
                <div class="collapse navbar-collapse" id="navbarNav" style="flex-grow: unset;">
                    <ul class="navbar-nav me-auto mx-auto list-group list-group-flush">
                        <li class="nav-item list-group-item list-menu-item">
                            <a class="nav-link" routerLinkActive="active" [routerLink]="['/home']">{{'Home' | translate}}</a>
                        </li>
                        <li class="nav-item list-group-item list-menu-item">
                            <a class="nav-link" routerLinkActive="active" [routerLink]="['/work']">{{'Work' | translate}}</a>
                        </li>
                        <li class="nav-item list-group-item list-menu-item">
                            <a class="nav-link" routerLinkActive="active" [routerLink]="['/about']">{{'About' | translate}}</a>
                        </li>
                        <!-- <li class="nav-item list-group-item list-menu-item">
                            <a class="nav-link" [routerLink]="['/service']">{{'Services' | translate}}</a>
                        </li> -->
                        <li class="nav-item list-group-item list-menu-item">
                            <a class="nav-link" routerLinkActive="active" [routerLink]="['/facilities']">{{'Facilities' | translate}}</a>
                        </li>
                        <li class="nav-item list-group-item list-menu-item">
                            <a class="nav-link" routerLinkActive="active" [routerLink]="['/contact']">{{'Contact' | translate}}</a>
                        </li>
                        <li class="nav-item list-group-item list-menu-item">
                            <a class="nav-link" routerLinkActive="active" [routerLink]="['/career']">{{'Career' | translate}}</a>
                        </li>
                        <li class="nav-item nav-dropdown list-group-item list-menu-item">
                            <a class="nav-link dropdown-toggle" id="navbarDropdown" (click)="dropdownMenu()" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">{{'Language' | translate}}</a>
                            <div id="headerDropdown" class="dropdown-menu" aria-labelledby="navbarDropdown">
                                <a class="dropdown-item" (click)="switchLang('en')">{{'English' | translate}}</a>
                                <a class="dropdown-item" (click)="switchLang('cn')">{{'Chinese' | translate}}</a>
                            </div>
                        </li>
                    </ul>
                    <!-- <span class="navbar-text d-none d-lg-inline">
                        <a  class="text-decoration-none"><i class="fas fa-phone" style="font-size: 12px;"></i>  +603 92016799</a>
                    </span> -->
                </div>
            </div>
        </nav>
    </div>
</div>